import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SIGN_UP_LINK = "https://sync.beatoven.ai/?action=signup" 

const Bottom = ({ heading, paragraph, ctaButton = "Start Creating For Free" }) => {
  const location = useLocation();

  const [abValue, setAb] = useState("control");

  const trackOutboundLink = (event, label, href, extra={}) => {

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    window.dataLayer.push({
      event: "custom_event",
      eventModel: {
        event_action: label,
        event_category: 'signin-signup',
        event_label: label,
        value: abValue,
        non_interaction: false,
      },
      ...extra,
    });

    setTimeout(() => {
      window.location.href = href;
    },100);

    event.preventDefault();
    return true;
  }

  return (
    <div className="rounded-2xl bg-wave1 bg-no-repeat bg-center py-14 mobile:px-2 mobile:h-auto mobile:py-6">
      <div className="flex flex-col justify-center items-center">
        <h2 className="font-poppins font-bold text-white text-4xl leading-10 text-center mobile:text-2xl sm:text-3xl px-14 mobile:px-0">
          {heading}
        </h2>
        {paragraph ? (
          <p className="font-normal font-mulish text-3xl leading-9 text-white opacity-80 py-6 text-center max-w-2xl mobile:leading-6 mobile:text-xl mobile:px-2 sm:px-2">
            {paragraph}
          </p>
        ) : null}
        {location.pathname === "/api" ? (
          <a 
            href="#contactc"
            type="button"
            class="focus:outline-none z-50 text-black bg-green shadow-button block text-center font-medium font-poppins rounded-xl max-w-md text-base px-14 py-2.5 hover:shadow-button-lg mobile:px-8 mobile:mb-4"
          >
            Get in Touch
          </a>
        ) : (
          <a
            href={`${SIGN_UP_LINK}`}
            target="_blank"
            rel="noreferrer"
            type="button"
            class="focus:outline-none z-50 text-black bg-green  shadow-button font-medium rounded-lg text-sm px-20 py-2.5 mb-4 mt-6 hover:shadow-button-lg mobile:px-4"
            onClick={e => trackOutboundLink(e, "SIGNUP-CTA-3", SIGN_UP_LINK )}
          >
            {ctaButton}
          </a>
        )}
      </div>
    </div>
  );
};

export default Bottom;
